function ImageModal({ open, image, onClose }) {
    if (!open) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 mt-28">
            <div className="bg-white p-4 rounded-md lg:w-[85vw] max-h-[90vh] overflow-auto">
                <img
                    src={image}
                    alt="Enlarged view"
                    className="md:w-[100vw] max-h-[70vh] object-contain"
                />
                <button
                    onClick={onClose}
                    className="mt-2 w-full px-4 py-2 bg-gray-300 hover:bg-gray-400 text-black rounded-md transition-colors"
                >
                    Close
                </button>
            </div>
        </div>
    );
}

export default ImageModal;